import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getProductSetDetailFetchSuccess,
    getProductSetDetailFetchFailure,
    createProductSetDetailFetchSuccess,
    createProductSetDetailFetchFailure,
    updateProductSetDetailFetchSuccess,
    updateProductSetDetailFetchFailure,
    deleteProductSetFetchSuccess,
    deleteProductSetFetchFailure,
} from './reducer';
import { ProductSetDetailResType } from 'src/types/productSetDetail';
import { ProductSetType } from 'src/types/productSet';
import translate from '@translate';

const getProductSetDetailFetchRequest = async (setSKU: string) => {
    const res = await api('get', `api/secure/products/set/${window.btoa(setSKU)}`);
    return res.data;
};

function* getProductSetDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ProductSetDetailResType = yield call((): any =>
            getProductSetDetailFetchRequest(action.payload)
        );
        yield put(getProductSetDetailFetchSuccess(response));
    } catch (error) {
        yield put(getProductSetDetailFetchFailure({ error }));
    }
}

export function* getProductSetDetailFetchWatch() {
    yield takeEvery('productSetDetail/getProductSetDetailFetch', getProductSetDetailFetch);
}

const createProductSetDetailFetchRequest = async (data: ProductSetType) => {
    const res = await api('post', 'api/secure/products/set', data);
    return res.data;
};

function* createProductSetDetailFetch(action: { type: string; payload: ProductSetType }) {
    try {
        const response: ProductSetDetailResType = yield call((): any =>
            createProductSetDetailFetchRequest(action.payload)
        );
        yield put(
            createProductSetDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('productSets.message.productSetCreated') },
            })
        );
    } catch (error) {
        yield put(createProductSetDetailFetchFailure({ error }));
    }
}

export function* createProductSetDetailFetchWatch() {
    yield takeEvery('productSetDetail/createProductSetDetailFetch', createProductSetDetailFetch);
}

const updateProductSetDetailFetchRequest = async (params: { setSKU: string; data: ProductSetType }) => {
    const res = await api('put', `api/secure/products/set/${window.btoa(params.setSKU)}`, params.data);
    return res.data;
};

function* updateProductSetDetailFetch(action: { type: string; payload: { setSKU: string; data: ProductSetType } }) {
    try {
        const response: ProductSetDetailResType = yield call((): any =>
            updateProductSetDetailFetchRequest(action.payload)
        );
        yield put(
            updateProductSetDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('productSets.message.productSetUpdate') },
            })
        );
    } catch (error) {
        yield put(updateProductSetDetailFetchFailure({ error }));
    }
}

export function* updateProductSetDetailFetchWatch() {
    yield takeEvery('productSetDetail/updateProductSetDetailFetch', updateProductSetDetailFetch);
}

const deleteProductSetFetchRequest = async (setSKU: string) => {
    const res = await api('delete', `api/secure/products/set/${window.btoa(setSKU)}`);
    return res.data;
};

function* deleteProductSetFetch(action: { type: string; payload: string }) {
    try {
        const response: ProductSetDetailResType = yield call((): any => deleteProductSetFetchRequest(action.payload));
        yield put(
            deleteProductSetFetchSuccess({
                ...response,
                messageSuccess: { title: translate('productSets.message.productSetDeleted') },
            })
        );
    } catch (error) {
        yield put(deleteProductSetFetchFailure({ error }));
    }
}

export function* deleteProductSetFetchWatch() {
    yield takeEvery('productSetDetail/deleteProductSetFetch', deleteProductSetFetch);
}
